import { saveSessionQuery } from './getSessionQuery.js';
import { isURL } from './url.js';
export const adjustSessionQuery = (href) => {
    const sessionQuery = saveSessionQuery();
    if (!isURL(href) || !sessionQuery) {
        return href;
    }
    const url = new URL(href);
    for (const [key, value] of new URLSearchParams(sessionQuery)) {
        url.searchParams.set(key, value);
    }
    return url.toString();
};
//# sourceMappingURL=adjustSessionQuery.js.map